import "../../../chunks/index-server.js";
import { b as escape_html, o as unsubscribe_stores, y as attr } from "../../../chunks/server.js";
import "../../../chunks/index-server2.js";
import { n as Plot } from "../../../chunks/stores.js";
//#region src/routes/store/+page.svelte
function _page($$renderer, $$props) {
	$$renderer.component(($$renderer) => {
		var $$store_subs;
		let totalPrice = 0;
		let plantTrees = false;
		let currentPlot = new Plot("0", 0, false);
		$$renderer.push(`<div class="flex justify-center p-12"><div id="map" style="height: 600px; width: 800px;"></div> <div class="flex flex-col items-center w-[300px] p-4 bg-white"><div class="flex flex-col my-6">`);
		$$renderer.push("<!--[0-->");
		$$renderer.push(`<span class="text-2xl">Selected Plot</span> <span class="text-xl mt-2">Plot Id: ${escape_html(currentPlot.id)}</span> <span class="text-xl">Price: ${escape_html(currentPlot.price)}€</span>`);
		$$renderer.push(`<!--]--> `);
		if (currentPlot.id !== "0" && true) {
			$$renderer.push("<!--[0-->");
			$$renderer.push(`<div class="flex items-center mt-2"><input${attr("checked", plantTrees, true)} id="checkbox" type="checkbox" value="" class="w-4 h-4 border border-default-medium rounded-xs bg-neutral-secondary-medium focus:ring-2 focus:ring-brand-soft"/> <label for="checkbox" class="select-none ms-2 text-heading">Plant trees for 25.99€?</label></div>`);
		} else $$renderer.push("<!--[-1-->");
		$$renderer.push(`<!--]--> `);
		$$renderer.push("<!--[0-->");
		$$renderer.push(`<span class="text-xl mt-4">Total: ${escape_html(totalPrice)}€</span>`);
		$$renderer.push(`<!--]--></div> `);
		if (currentPlot.id !== "0" && true) {
			$$renderer.push("<!--[0-->");
			$$renderer.push(`<button class="bg-yellow-500 hover:bg-yellow-600 px-5 py-2 rounded-full cursor-pointer">Add To Cart</button>`);
		} else $$renderer.push("<!--[-1-->");
		$$renderer.push(`<!--]--></div></div>`);
		if ($$store_subs) unsubscribe_stores($$store_subs);
	});
}
//#endregion
export { _page as default };
